import React from 'react';
import './ThingsToDoSection.scss';

interface ThingsToDoSectionProps {
    wrappingClasses?: string;
}

/**
 * Simple component that will provide consistent spacing
 * between sections
 */
export const ThingsToDoSection: React.FunctionComponent<
    ThingsToDoSectionProps
> = (props) => {
    const { wrappingClasses } = props;
    const classes = wrappingClasses ? wrappingClasses : '';

    return (
        <section
            className={`ttd-sections eds-l-pad-top-16 eds-l-sw-pad-vert-16 eds-l-sm-pad-vert-16 eds-l-sn-pad-vert-16 ${classes}`}
        >
            {props.children}
        </section>
    );
};
